module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid5_800x643.5bb26c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid5_800x643.jpg
// module id = N5h8
// module chunks = 0